import React, {Component} from 'react';
import {LINK_TYPE_REDIRECT_DELAY} from '../../../constants';


class LinkType extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {
        const {href, redirect, redirectTimeout, doRedirect} = this.props;
        if (redirect) {
            const timeout = !isFinite(redirectTimeout)? LINK_TYPE_REDIRECT_DELAY: redirectTimeout;
            if (timeout > 0) {
                const timerId = setTimeout(() => doRedirect(href), timeout);
                this.setState({timerId});
            }
        }
    }

    componentWillUnmount() {
        if (this.state.timerId) {
            clearTimeout(this.state.timerId);
        }
    }

    handleClick() {
        if (this.state.timerId) {
            clearTimeout(this.state.timerId);
        }
        this.props.doRedirect(this.props.href);
    }

    render() {
        const {text, href, blank, redirect} = this.props;
        const target = blank === true ? '_blank' : undefined;
        const rel = redirect === true || blank === true ? 'noopener' : undefined;

        return (
            <div className="mt-2 text-center">
                {redirect === true ?
                    <a className="btn btn-primary link-button" onClick={this.handleClick} rel={rel} role="button">
                        {text}
                    </a> :
                    <a className="btn btn-primary link-button" href={href} target={target} rel={rel} role="button">
                        {text}
                    </a>
                }
            </div>
        );
    }
}

export default LinkType;
